import { render, staticRenderFns } from "./zones.vue?vue&type=template&id=4882197f&scoped=true&"
import script from "./zones.vue?vue&type=script&lang=js&"
export * from "./zones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4882197f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4882197f')) {
      api.createRecord('4882197f', component.options)
    } else {
      api.reload('4882197f', component.options)
    }
    module.hot.accept("./zones.vue?vue&type=template&id=4882197f&scoped=true&", function () {
      api.rerender('4882197f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/zones.vue"
export default component.exports